import { ApiService } from '../../common'

export class AppTasksApi extends ApiService {}
